module.exports = __webpack_public_path__ + "img/feature-9.ec05a391.png";